import React, { Children } from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Map, MessageCircle, Wind, HeartHandshake } from 'lucide-react';
import { motion } from 'framer-motion';
export function DeliverablesSection() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-gold" data-id="element-14" />,
    title: 'El eBook Maestro',
    description: 'El Código de la Suavidad (Guía completa).'
  }, {
    icon: <Map className="w-6 h-6 text-gold" data-id="element-15" />,
    title: 'El Inventario de Cargas',
    description: 'Mapa para identificar qué responsabilidades no te pertenecen.'
  }, {
    icon: <MessageCircle className="w-6 h-6 text-gold" data-id="element-16" />,
    title: "Protocolo 'Límites de Seda'",
    description: "Frases exactas para decir 'No' con elegancia y firmeza."
  }, {
    icon: <Wind className="w-6 h-6 text-gold" data-id="element-17" />,
    title: 'Ejercicios de Descenso',
    description: "Micro-rituales de 5 minutos para apagar la 'jefa' y encender la 'mujer'."
  }, {
    icon: <HeartHandshake className="w-6 h-6 text-gold" data-id="element-18" />,
    title: 'Guía de Petición Vulnerable',
    description: 'Cómo pedir ayuda de forma que los demás quieran apoyarte.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-cream" data-id="element-19">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <FadeIn data-id="element-21">
          <div className="text-center mb-16" data-id="element-22">
            <h2 className="text-4xl md:text-5xl font-serif text-brown mb-6" data-id="element-23">
              Lo que recibirás hoy
            </h2>
            <p className="text-xl text-brown/70 max-w-2xl mx-auto" data-id="element-24">
              Un sistema completo diseñado para transformar tu energía y
              recuperar tu paz mental.
            </p>
          </div>
        </FadeIn>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-25">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-gold/10" data-id="element-26">
              <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center mb-6" data-id="element-27">
                {item.icon}
              </div>
              <h3 className="text-xl font-serif text-brown font-bold mb-3" data-id="element-28">
                {item.title}
              </h3>
              <p className="text-brown/70 leading-relaxed" data-id="element-29">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}